import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { UpdateBillingProfilePaymentMethod } from '../helpers/update-billing-profile-payment-method';
import { getDefaultBillingProfile } from '../helpers/get-default-billing-profile';

interface AddPaymentMethodStripeFnPayload {
    stripePaymentMethodId: string;
}

export type AddPaymentMethodStripeFn = (
    payload: AddPaymentMethodStripeFnPayload,
) => Promise<unknown>;

export function initAddPaymentMethodStripeFn({
    dependencies,
}: DomainInitPayload): AddPaymentMethodStripeFn {
    return async ({
        stripePaymentMethodId,
    }: AddPaymentMethodStripeFnPayload) => {
        const { id: billingProfileId } =
            await getDefaultBillingProfile(dependencies);
        await UpdateBillingProfilePaymentMethod(
            billingProfileId,
            stripePaymentMethodId,
            dependencies,
        );
    };
}
